"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/function-component-definition */
/* eslint-disable react/require-default-props */
const react_1 = __importStar(require("react"));
const react_phone_input_2_1 = __importDefault(require("react-phone-input-2"));
const utils_1 = require("~/utils/utils");
const assets_1 = require("~/assets");
const config_1 = require("~/consts/config");
const types_1 = require("~/store/types");
require("react-phone-input-2/lib/high-res.css");
const PhoneNumberInput_scss_1 = __importDefault(require("./PhoneNumberInput.scss"));
const PhoneNumberInput = ({ inputKey, state: { error, value }, onInput, onError, required = false, country = config_1.DEFAULT_COUNTRY, prefferedCountries = config_1.PREFFERED_COUNTRIES, }) => {
    const [focused, setFocused] = (0, react_1.useState)(false);
    const [validate, setValidate] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        if (!focused && validate && required) {
            if (!value || value.trim().length === 0) {
                onError(inputKey, types_1.INPUT_ERRORS.required);
                return;
            }
            if (!(0, utils_1.validatePhoneNumber)(value)) {
                onError(inputKey, types_1.INPUT_ERRORS.invalid);
                return;
            }
        }
        onError(inputKey, types_1.INPUT_ERRORS.none);
    }, [focused, validate, required, value]);
    const changeHandler = (phone) => {
        onInput(inputKey, phone);
    };
    const focusHandler = () => {
        setFocused(true);
        setValidate(true);
    };
    const blurHandler = () => setFocused(false);
    return (react_1.default.createElement("div", { className: `${PhoneNumberInput_scss_1.default.container} ${error ? PhoneNumberInput_scss_1.default.error : ''}` },
        react_1.default.createElement(react_phone_input_2_1.default, { value: value, onChange: changeHandler, onFocus: focusHandler, onBlur: blurHandler, inputClass: PhoneNumberInput_scss_1.default.input, containerClass: PhoneNumberInput_scss_1.default.dropdown, preferredCountries: prefferedCountries, country: country }),
        error ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: PhoneNumberInput_scss_1.default.icon },
                react_1.default.createElement("img", { src: assets_1.svgSystemError })),
            react_1.default.createElement("div", { className: PhoneNumberInput_scss_1.default.error }, error))) : null));
};
exports.default = PhoneNumberInput;
